import {makeAutoObservable} from 'mobx';
import API from '../../APIs/API';
import AthenaAPI from '../../APIs/AthenaAPI';
import {AgentStore} from '../../Agent/AgentStore';
import {FamilyQuoteStore} from '../../Agent/Contacts/FamilyQuoteStore';
import {User} from '../../Auth/User';
import {CaseManagerStore} from '../../CaseManager/CaseManagerStore';
import {LiveCallStore} from '../../LiveCall/LiveCallStore';
import {UserAdminStore} from '../../UserAdmin/UserAdminStore';
import {UiStore} from './UiStore/UiStore';
import {AssistStore} from '../../Agent/Assist/AssistStore';
import {ABFlagsStore} from './ABFlagsStore';

export class RootStore {
    agentPortalStore = new AgentStore(this);
    caseManagerStore = new CaseManagerStore(this);
    familyQuoteStore = new FamilyQuoteStore();
    userAdminStore = new UserAdminStore();
    liveTabStore = new LiveCallStore();
    assistStore = new AssistStore(this);
    abFlagsStore = new ABFlagsStore();
    agentsList: string[] = [];
    currentAgentStates: string[] = [];

    uiStore = new UiStore();

    constructor() {
        makeAutoObservable(this);
    }

    async fetchAgents() {
        try {
            let agents = await API.Call<any>('agents');
            const formattedAgents: string[] = agents.reduce((list: any[], item: any) => {
                list.push(item.s);
                return list;
            }, []);
            this.agentsList = formattedAgents;
        } catch (error) {
            console.error('Error fetching agents:', error);
            this.agentsList = [];
        }
    }

    async fetchAgentStates() {
        try {
            this.currentAgentStates = (await AthenaAPI.getStatesForAgent(User.Info.email)).states;
        } catch (error) {
            console.error('Error fetching agent states:', error);
            this.currentAgentStates = [];
        }
    }

    reset = () => {
        this.agentPortalStore = new AgentStore(this);
        this.caseManagerStore = new CaseManagerStore(this);
        this.familyQuoteStore = new FamilyQuoteStore();
        this.abFlagsStore = new ABFlagsStore();
    };
}

export default new RootStore();
